var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "c-application-appartment" }, [
        _vm.url
          ? _c(
              "button",
              {
                staticClass: "c-button c-button--icon c-button--highlight",
                on: { click: _vm.toggleModalStep2 }
              },
              [
                _c("span", { staticClass: "c-application-appartment--decoy" }),
                _vm._v(" "),
                _c("span", { staticClass: "c-button--right" }, [
                  _vm._v(_vm._s(_vm.buttonTexts.applyText))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "c-application-appartment--scale" },
                  [
                    _c("v-icon", {
                      attrs: {
                        name: "icon-arrow",
                        cssModifiers: _vm.whiteIcon + " arrow-icon--padding",
                        size: "s"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showKeepUpdatedButton === "1"
          ? _c(
              "button",
              {
                class: [
                  "c-button",
                  "c-button--icon",
                  _vm.showKeepUpdatedButtonHighlighted === "1"
                    ? "c-button--highlight"
                    : "c-button--secondary"
                ],
                attrs: { target: "_blank" },
                on: { click: _vm.toggleModalUpdateOnly }
              },
              [
                _c("span", { staticClass: "c-application-appartment--decoy" }),
                _vm._v(" "),
                _c("span", { staticClass: "c-button--right" }, [
                  _vm._v(_vm._s(_vm.buttonTexts.keepUpdatedText))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "c-application-appartment--scale c-application-appartment--padding"
                  },
                  [
                    _c("v-icon", {
                      attrs: {
                        name: "icon-arrow",
                        cssModifiers: _vm.whiteIcon + " arrow-icon--padding",
                        size: "s"
                      }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "c-application-appartment-container" }, [
          _vm.infoUrl
            ? _c(
                "a",
                {
                  staticClass: "c-application-appartment-link",
                  attrs: { target: "_blank", href: _vm.infoUrl }
                },
                [_vm._v(_vm._s(_vm.buttonTexts.infoText))]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.showModal
        ? _c("v-modal", {
            attrs: { close: _vm.toggleModal },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      !_vm.stepOneCompleted
                        ? _c(
                            "div",
                            { staticClass: "c-application-modal-content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-application-modal-content-container"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "c-application-modal-content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.modalPartOne.heading))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-subtitle"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.modalPartOne.subHeading)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-text"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.modalPartOne.text) + "."
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "form",
                                {
                                  staticClass: "c-application-modal-form",
                                  attrs: { method: "post" },
                                  on: { submit: _vm.handleSubmit }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-application-modal-form-input--container"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.name,
                                            expression: "formData.name"
                                          }
                                        ],
                                        ref: "textfield",
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.mFormPlaceholders.name,
                                          required: true
                                        },
                                        domProps: { value: _vm.formData.name },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-application-modal-form-input--container"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.formData.email,
                                            expression: "formData.email"
                                          }
                                        ],
                                        attrs: {
                                          type: "email",
                                          placeholder:
                                            _vm.mFormPlaceholders.email,
                                          required: !_vm.formData.phone
                                        },
                                        domProps: { value: _vm.formData.email },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.formData,
                                              "email",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-application-modal-button-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-application-appartment-container"
                                        },
                                        [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "c-application-appartment-button--link",
                                              attrs: {
                                                type: "button",
                                                target: "_blank"
                                              },
                                              on: { click: _vm.toggleModal }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.mOneButtons
                                                    .cancelButtonText
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "c-button c-button--icon c-button--highlight",
                                          attrs: { type: "submit" }
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "c-button--right" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.url && !_vm.updateOnly
                                                    ? _vm.mOneButtons
                                                        .nextButtonText
                                                    : _vm.mOneButtons
                                                        .nextButtonTextAlternative
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "c-application-appartment--scale c-application-appartment--padding"
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "icon-arrow",
                                                  cssModifiers:
                                                    _vm.whiteIcon +
                                                    " arrow-icon--padding",
                                                  size: "s"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stepOneCompleted &&
                      _vm.url &&
                      !_vm.updateOnly &&
                      !_vm.apiError.error
                        ? _c(
                            "div",
                            { staticClass: "c-application-modal-content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-application-modal-content-container"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "c-application-modal-content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.modalPartTwo.heading))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-subtitle"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.modalPartTwo.subHeading)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-text"
                                    },
                                    [_vm._v(_vm._s(_vm.modalPartTwo.text))]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.stepTexts, function(step, index) {
                                return [
                                  _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass:
                                        "c-application-modal-container"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-application-modal-step-container--left"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "c-application-modal__circle"
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "c-application-modal__circle-text"
                                                },
                                                [_vm._v(_vm._s(step.number))]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          index !== _vm.stepTexts.length - 1
                                            ? _c("div", {
                                                staticClass:
                                                  "c-application-modal__line"
                                              })
                                            : _vm._e()
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "c-application-modal-step-container--right"
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-application-modal-content-subtitle"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(step.stepSubHeading)
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "c-application-modal-content-text"
                                            },
                                            [_vm._v(_vm._s(step.text) + ".")]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-application-modal-container--column"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-application-modal-bottom-container"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "c-application-appartment-link",
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.mTwoLinks.explainLink
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.mTwoLinks.explainLinkText
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "c-application-appartment-link",
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.mTwoLinks.processInfoLink
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.mTwoLinks.processInfoLinkText
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "c-application-modal-button-container"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "c-button c-button--icon c-button--highlight",
                                          attrs: {
                                            target: "_blank",
                                            href: _vm.url
                                          },
                                          on: { click: _vm.toggleUpdate }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.mTwoLinks.button) +
                                              "\n                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "c-application-appartment--scale c-application-appartment--padding"
                                            },
                                            [
                                              _c("v-icon", {
                                                attrs: {
                                                  name: "icon-arrow",
                                                  cssModifiers:
                                                    _vm.whiteIcon +
                                                    " arrow-icon--padding arrow-icon--negmargin",
                                                  size: "s"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stepOneCompleted &&
                      _vm.updateOnly &&
                      !_vm.apiError.error
                        ? _c(
                            "div",
                            { staticClass: "c-application-modal-content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-application-modal-content-container"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "c-application-modal-content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.modalPartTwo.heading))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-text"
                                    },
                                    [_vm._v(_vm._s(_vm.modalDone))]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.stepOneCompleted && _vm.apiError.error
                        ? _c(
                            "div",
                            { staticClass: "c-application-modal-content" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "c-application-modal-content-container"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      staticClass:
                                        "c-application-modal-content-title"
                                    },
                                    [_vm._v(_vm._s(_vm.apiError.errHeading))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "c-application-modal-content-text"
                                    },
                                    [_vm._v(_vm._s(_vm.apiError.msg))]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3970926722
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }